import { useCallback, useRef, useState } from 'react';
import type { FlatListProps } from 'react-native';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

type CarouselItem = {
  item_list: ReadonlyArray<{
    logging: { analytics: { LIST_ID: string } };
  }>;
};

export const useLogDisplayCarousel = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const loggedListIdsRef = useRef(new Set<string>());
  const [viewedIndices, setViewedIndices] = useState<ReadonlySet<number>>(
    () => new Set(),
  );

  const onViewableItemsChanged = useCallback<
    NonNullable<FlatListProps<CarouselItem>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      viewableItems.forEach(({ isViewable, item }) => {
        if (!isViewable) return;
        const listId = `${item.item_list[0]?.logging.analytics.LIST_ID}`;
        if (loggedListIdsRef.current.has(listId)) return;
        loggedListIdsRef.current.add(listId);
        logGoodsAnalytics({
          name: 'DISPLAY_CAROUSEL',
          analytics: { LIST_ID: listId },
        });
      });

      setViewedIndices(prev => {
        let changed = false;
        const next = new Set(prev);
        viewableItems.forEach(({ isViewable, index }) => {
          if (isViewable && index !== null && !next.has(index)) {
            next.add(index);
            changed = true;
          }
        });
        return changed ? next : prev;
      });
    },
    [logGoodsAnalytics],
  );

  return { onViewableItemsChanged, viewedIndices };
};
